<template>
    <customModal :containersm=true :bodysm=true :footerShow=true @closeModal="closeDisModal">
        <template #title>
            <h4 class="my-0">
                {{ $t("navigations.discrepancy") }} 
            </h4>
        </template>
        <template #body>
          <div class="row">
                <div class="col-lg-12">
                    <label >{{ $t("navigations.reason") }}</label>
                    <select 
                        class="form-control" 
                        placeholder="Select reason" 
                        v-model="sdvPayload.discrepancyReason">
                        <option value="" disabled selected>
                            {{ $t("navigations.select reason") }}
                        </option>
                        <option v-for="reason in reasonsList" :key="reason._id" :value="reason.ReasonLabel">
                            {{ reason.ReasonLabel }} 
                        </option>
                    </select>
                </div>
                <div class="col-lg-12 mt-3">
                    <label for="message">{{ $t('navigations.comments') }}</label>
                    <textarea 
                        class="form-control" 
                        v-model="sdvPayload.sdvVerificationComments"  
                        placeholder="Message" id="message"  
                        minlength="10" spellcheck="true">
                    </textarea>
                </div>
          </div>  
        </template>
        <template #footer>
            <button 
                class="btn btn-primary btn-sm  float-right py-0 mb-2"
                @click="verifySourceData()">
                <i class="fa fa-check me-1"></i> Submit
            </button>
        </template>
    </customModal>
</template>

<script src="./SDV_Discrepancymodal.js"></script>